import { __, sprintf } from "@wordpress/i18n";
import { ReactComponent as Smash } from "./assets/smash.svg";
import { ReactComponent as YouTube } from "./assets/youtube.svg";
import { ReactComponent as Facebook } from "./assets/facebook.svg";
import { ReactComponent as Instagram } from "./assets/instagram.svg";
import { ReactComponent as Twitter } from "./assets/twitter.svg";

import { useState } from "react";

const ProductIcon = ({ product }) => {
  switch (product) {
    case "youtube":
      return <YouTube />;
    case "facebook":
      return <Facebook />;
    case "instagram":
      return <Instagram />;
    case "twitter":
      return <Twitter />;
    case "smash":
      return <Smash />;
    default:
      return null;
  }
};

const StickyWidget = () => {
  const { smashBalloonInfo } = window.sby_settings;
  const [showMenu, setShowMenu] = useState(false);
  return (
    <div className="sby-stck-wdg">
      {showMenu && (
        <div className="sby-stck-pop">
          <div className="sby-stck-el sby-stck-el-upgrd sb-btn-orange">
            <div className="sby-stck-el-icon">
              <YouTube />
            </div>
            <div
              className="sby-stck-el-txt sb-small-p sb-bold"
              style={{
                color: "#FFFFFF",
              }}
            >
              {__("Get All Access Bundle", "feeds-for-youtube")}
            </div>
            <div className="sby-chevron">
              <svg
                width="7"
                height="10"
                viewBox="0 0 7 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.3332 0L0.158203 1.175L3.97487 5L0.158203 8.825L1.3332 10L6.3332 5L1.3332 0Z"
                  fill="white"
                />
              </svg>
            </div>
            <a
              href={sprintf(
                "https://smashballoon.com/all-access/?edd_license_key=%s&upgrade=true&utm_campaign=youtube-free&utm_source=all-feeds&utm_medium=footer-banner&utm_content=learn-more",
                window.sby_settings.licenseKey
              )}
              target="_blank"
              className="sby-fs-a"
            />
          </div>
          <div className="sby-stck-title">
            {__("Our Feeds for other platforms", "feeds-for-youtube")}
          </div>

          <div className="sby-stck-el-list sby-fb-fs">
            {smashBalloonInfo.platforms.map((platform) => {
              return (
                <div key={platform.name} className="sby-stck-el sby-fb-fs">
                  <div
                    className="sby-stck-el-icon"
                    style={{
                      color: smashBalloonInfo.colorSchemes[platform.icon],
                    }}
                  >
                    <ProductIcon product={platform.icon} />
                  </div>
                  <div className="sby-stck-el-txt sb-small-text sb-small-p sb-dark-text">
                    {platform.name}
                  </div>
                  <div className="sby-chevron">
                    <svg
                      width="7"
                      height="10"
                      viewBox="0 0 7 10"
                      fill="#8C8F9A"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.3332 0L0.158203 1.175L3.97487 5L0.158203 8.825L1.3332 10L6.3332 5L1.3332 0Z"
                        fill="#8C8F9A"
                      ></path>
                    </svg>
                  </div>
                  <a
                    href={platform.link}
                    target="_blank"
                    className="sby-fs-a"
                  />
                </div>
              );
            })}
          </div>

          <div className="sby-stck-follow sby-fb-fs">
            <span>{__("Follow Us", "feeds-for-youtube")}</span>
            <div className="sby-stck-flw-links">
              {Object.entries(smashBalloonInfo.socialProfiles).map(
                (social, key) => {
                  return (
                    <a
                      href={social}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: smashBalloonInfo.colorSchemes[key],
                      }}
                    >
                      {
                        <ProductIcon
                          product={
                            Object.keys(smashBalloonInfo.socialProfiles)[key]
                          }
                        />
                      }
                    </a>
                  );
                }
              )}
            </div>
          </div>
        </div>
      )}

      <div
        className="sby-stck-wdg-btn"
        onClick={() => {
          setShowMenu(!showMenu);
        }}
      >
        {!showMenu && (
          <span>
            <Smash />
          </span>
        )}
        {showMenu && (
          <div className="sby-stck-wdg-btn-cls">
            <svg
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.501 1.77279L13.091 0.362793L7.50098 5.95279L1.91098 0.362793L0.500977 1.77279L6.09098 7.36279L0.500977 12.9528L1.91098 14.3628L7.50098 8.77279L13.091 14.3628L14.501 12.9528L8.91098 7.36279L14.501 1.77279Z"
                fill="#141B38"
              />
            </svg>
          </div>
        )}
      </div>
    </div>
  );
};

export default StickyWidget;
